import { BaseApiRequest } from "../baseApiRequest";
import { Route } from "../../types/route";
import { XcoreCore } from "XcoreCore";

export const getRoute = (id: string | number, core: XcoreCore): BaseApiRequest<Route> =>
  core.fetch(`/api/route/${id}`).then((r) => r.json());
